import React, { useState, useEffect } from 'react';
import { logService } from '../../services/api';

const ActivityLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    try {
      const response = await logService.getAll();
      setLogs(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching logs:', error);
      setLoading(false);
    }
  };

  const [filterAction, setFilterAction] = useState('');
  const [filterEntity, setFilterEntity] = useState('');
  const [filterUser, setFilterUser] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const getActionBadge = (action) => {
    const badges = {
      'Created': 'bg-success',
      'Updated': 'bg-primary',
      'Deleted': 'bg-danger',
      'Viewed': 'bg-info',
      'Exported': 'bg-warning'
    };
    return badges[action] || 'bg-secondary';
  };

  const filteredLogs = logs.filter(log => {
    const matchesAction = !filterAction || log.action === filterAction;
    const matchesEntity = !filterEntity || log.entity === filterEntity;
    const matchesUser = !filterUser || log.user === filterUser;
    const matchesSearch = !searchTerm ||
      log.user.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.entity.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.details.toLowerCase().includes(searchTerm.toLowerCase()) ||
      log.entityId.toLowerCase().includes(searchTerm.toLowerCase());

    return matchesAction && matchesEntity && matchesUser && matchesSearch;
  });

  return (
    <div>
      <div className="d-flex justify-content-between align-items-start mb-4">
        <div>
          <h2 className="mb-1" style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            fontWeight: '700',
            fontSize: '2rem'
          }}>
            Activity Logs
          </h2>
          <p className="text-muted mb-0">View system activity and audit trails</p>
        </div>
      </div>

      <div className="card mb-4">
        <div className="card-header">
          <h5 className="mb-0">Filters</h5>
        </div>
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-3 mb-3">
              <label className="form-label">Search</label>
              <input
                type="text"
                className="form-control"
                placeholder="Search logs..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            <div className="col-md-3 mb-3">
              <label className="form-label">Filter by Action</label>
              <select
                className="form-select"
                value={filterAction}
                onChange={(e) => setFilterAction(e.target.value)}
              >
                <option value="">All Actions</option>
                <option value="Created">Created</option>
                <option value="Updated">Updated</option>
                <option value="Deleted">Deleted</option>
                <option value="Viewed">Viewed</option>
                <option value="Exported">Exported</option>
              </select>
            </div>
            <div className="col-md-3 mb-3">
              <label className="form-label">Filter by Entity</label>
              <select
                className="form-select"
                value={filterEntity}
                onChange={(e) => setFilterEntity(e.target.value)}
              >
                <option value="">All Entities</option>
                <option value="Record">Record</option>
                <option value="Tender">Tender</option>
                <option value="Quotation">Quotation</option>
                <option value="Project">Project</option>
                <option value="Organization">Organization</option>
                <option value="Contact">Contact</option>
                <option value="Stock">Stock</option>
                <option value="Reports">Reports</option>
              </select>
            </div>
            <div className="col-md-3 mb-3">
              <label className="form-label">Filter by User</label>
              <select
                className="form-select"
                value={filterUser}
                onChange={(e) => setFilterUser(e.target.value)}
              >
                <option value="">All Users</option>
                {[...new Set(logs.map(l => l.user))].map(user => (
                  <option key={user} value={user}>{user}</option>
                ))}
              </select>
            </div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">All Activity Logs</h5>
          <span className="badge bg-info">Total: {filteredLogs.length}</span>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Timestamp</th>
                  <th>User</th>
                  <th>Role</th>
                  <th>Action</th>
                  <th>Entity</th>
                  <th>Entity ID</th>
                  <th>Details</th>
                  <th>IP Address</th>
                  <th>MAC Address</th>
                </tr>
              </thead>
              <tbody>
                {filteredLogs.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="text-center text-muted">
                      No activity logs found
                    </td>
                  </tr>
                ) : (
                  filteredLogs.map((log) => (
                    <tr key={log.id}>
                      <td>{log.timestamp}</td>
                      <td><strong>{log.user}</strong></td>
                      <td>
                        <span className="badge bg-secondary">{log.role}</span>
                      </td>
                      <td>
                        <span className={`badge ${getActionBadge(log.action)}`}>
                          {log.action}
                        </span>
                      </td>
                      <td>{log.entity}</td>
                      <td><code>{log.entityId}</code></td>
                      <td>{log.details}</td>
                      <td><small className="text-muted">{log.ipAddress || 'Unknown'}</small></td>
                      <td><small className="text-muted">{log.macAddress || 'N/A'}</small></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivityLogs;

